import { Route, Routes } from "react-router-dom";

import Sidebar from "../components/MainSidebar";

import DisplayFaqs from "../pages/Faqs/DisplayFaqs";
import AddEditFaqs from "../pages/Faqs/AddEditFaqs";

import AddEditLanguages from "../pages/Languages/AddEditLanguages";
import DisplayLanguages from "../pages/Languages/DisplayLanguages";
import DisplayTestimonials from "../pages/Testimonials/DisplayTestimonials";
import AddEditTestimonials from "../pages/Testimonials/AddEditTestimonials";
import DisplayEnqiury from "../pages/Enquiries/DisplayEnquiry";
import AddEditEnquiry from "../pages/Enquiries/AddEditEnquiry";

import DisplayBookings from "../pages/Bookings/DisplayBookings";
import BookingDetails from "../pages/Bookings/BookingDetails";
import Dashboard from "../pages/Dashboard/Dashboard";
import DisplayService from "../pages/Services/DisplayService";
import AddEditService from "../pages/Services/AddEditService";
import DisplayAddOnService from "../pages/AddOnServices/DisplayAddOnService";
import AddEditAddOnService from "../pages/AddOnServices/AddEditAddOnService";
import DispalyPackageServices from "../pages/PackageServices/DispalyPackageServices";
import AddEditPackageServices from "../pages/PackageServices/AddEditPackageServices";
import DisplayTermsAndPrivacy from "../pages/TermsAndPrivacy/DisplayTermsAndPrivacy";
import AddEditTermsAndPrivacy from "../pages/TermsAndPrivacy/AddEditTermsAndPrivacy";
import DisplayBanner from "../pages/Banners/DisplayBanner";
import AddEditBanner from "../pages/Banners/AddEditBanner";
import DisplayTechnician from "../pages/Technicians/DisplayTechnician";
import AddEditTechnician from "../pages/Technicians/AddEditTechnicain";
import ViewTechnicianDetails from "../pages/Technicians/ViewTechnicianDetails";
import LoginPage from "../pages/Forms/Login";
import Details from "../pages/Forms/Details";
import DisplayShowroom from "../pages/Showroom/DisplayShowroom";
import AddEditShowroom from "../pages/Showroom/AddEditShowroom";
import ViewShowroomDetails from "../pages/Showroom/ViewShowroomDetails";
import DisplayOffers from "../pages/Offers/DisplayOffers";
import AddEditOffers from "../pages/Offers/AddEditOffers";
import DisplayVehicleBrands from "../pages/VehicleBrands/DisplayVehicleBrands";
import AddEditVehicleBrand from "../pages/VehicleBrands/AddEditVehicleBrand";
import DisplayVehicleModel from "../pages/VehicleModel/DisplayVehicleModel";
import AddEditVehicleModel from "../pages/VehicleModel/AddEditVehicleModel";
import DispayReferalConfig from "../pages/ReferalConfig/DispayReferalConfig";
import AddEditReferalConfig from "../pages/ReferalConfig/AddEditReferalConfig";
import DisplayDeliveryRange from "../pages/DeliveryRange/DisplayDeliveryRange";
import AddEditDeliveryRange from "../pages/DeliveryRange/AddEditDeliveryRange";
import DisplayTaxConfig from "../pages/GstAndTax/DisplayTaxConfig";
import AddEditTaxConfig from "../pages/GstAndTax/AddEditTaxConfig";
import DisplayUsers from "../pages/Users/DisplayUsers";
import ViewUserDetails from "../pages/Users/ViewUserDetails";
import DisplayTimeslot from "../pages/Timeslot/DisplayTimeslot";
import AddEditTimeSlots from "../pages/Timeslot/AddEditTimeSlots";
import DisplayRadius from "../pages/DeliveryRadius/DisplayRadius";
import AddEditRadius from "../pages/DeliveryRadius/AddEditRadius";
import DisplayRoles from "../pages/Roles/DisplayRoles";
import AddEditRoles from "../pages/Roles/AddEditRoles";
import RolePermissions from "../pages/Roles/RolePermissions";
import Permissions from "../pages/Roles/Permissions";
import DisplayEmployees from "../pages/Employee/DisplayEmployees";
import AddEditEmployee from "../pages/Employee/AddEditEmployee";
import Login from "../components/Login";

import { useContext, useEffect, useState } from "react";
import Context from "../context/Context";
import AddEditBankDetails from "../pages/BankDetails/AddEditBankDetails";
import TechnicianPayouts from "../pages/Technicians/TechnicianPayouts";
import ShowroomPayouts from "../pages/Showroom/ShowroomPayouts";
import DisplayCancellationPolicy from "../pages/Cancellation policy/DisplayCancellationPolicy";
import AddEditCancellationPolicy from "../pages/Cancellation policy/AddEditCancellationPolicy";
import AssignTechnician from "../pages/Technicians/AssignTechnician";
import PushNotifications from "../pages/PushNotifications/PushNotifications";
import UpdateShowroomPayouts from "../pages/Showroom/UpdateShowroomPayouts";
import UpdateTechnicianPayouts from "../pages/Technicians/UpdateTechnicianPayouts";

const PageRoutes = () => {
  const { myPermissions, getMyPermissions } = useContext(Context);
  useEffect(() => {
    getMyPermissions();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/display-dashboard" element={<Dashboard />} />

        {/* languages */}
        <Route path="/display-languages" element={<DisplayLanguages />} />
        <Route path="/create-edit-languages" element={<AddEditLanguages />} />

        {/* faqs */}
        <Route path="/display-faqs" element={<DisplayFaqs />} />
        <Route path="/create-edit-faqs" element={<AddEditFaqs />} />

        {/*  */}
        <Route path="/display-testimonials" element={<DisplayTestimonials />} />
        <Route
          path="/create-edit-testimonials"
          element={<AddEditTestimonials />}
        />

        {/* enquiries */}
        <Route path="/display-enquiry" element={<DisplayEnqiury />} />
        {/* <Route path="/create-edit-enquiry" element={<AddEditEnquiry />} /> */}

        {/* Services */}
        <Route path="/display-service" element={<DisplayService />} />
        <Route path="/create-edit-service" element={<AddEditService />} />

        {/* AddOn Services */}
        <Route
          path="/display-addon-service"
          element={<DisplayAddOnService />}
        />
        <Route
          path="/create-edit-addon-service"
          element={<AddEditAddOnService />}
        />

        {/* Package Services */}
        <Route
          path="/display-package-service"
          element={<DispalyPackageServices />}
        />
        <Route
          path="/create-edit-package-service"
          element={<AddEditPackageServices />}
        />

        {/* terms and conditions ,privacy policies */}
        <Route
          path="/display-terms-privacies"
          element={<DisplayTermsAndPrivacy />}
        />
        <Route
          path="/create-edit-terms-privacies"
          element={<AddEditTermsAndPrivacy />}
        />

        <Route path="/display-bookings" element={<DisplayBookings />} />
        <Route
          path="/booking-details/:bookingId"
          element={<BookingDetails />}
        />

        {/* Banner */}
        <Route path="/display-banners" element={<DisplayBanner />} />
        <Route path="/create-edit-banner" element={<AddEditBanner />} />

        {/* Technicain */}
        <Route path="/display-technicians" element={<DisplayTechnician />} />
        <Route
          path="/create-edit-techinician"
          element={<AddEditTechnician />}
        />
        <Route
          path="/view-techinician-details"
          element={<ViewTechnicianDetails />}
        />
        <Route path="/technician-payouts" element={<TechnicianPayouts />} />
        <Route
          path="/assign-technician/:bookingId"
          element={<AssignTechnician />}
        />
        <Route path="/technician/update-payouts/:id" element={<UpdateTechnicianPayouts />} />

        {/* show room */}
        <Route path="/display-showrooms" element={<DisplayShowroom />} />
        <Route path="/create-edit-showroom" element={<AddEditShowroom />} />
        <Route
          path="/view-showroom-details"
          element={<ViewShowroomDetails />}
        />
        <Route path="/showroom-payouts" element={<ShowroomPayouts />} />
        <Route path="/showroom/update-payouts/:id" element={<UpdateShowroomPayouts />} />

        {/* Offers */}
        <Route path="/display-offers" element={<DisplayOffers />} />
        <Route path="/create-edit-offers" element={<AddEditOffers />} />

        {/* Vehicle Branding */}
        <Route
          path="/display-vehicle-brands"
          element={<DisplayVehicleBrands />}
        />
        <Route
          path="/create-edit-vehicle-brand"
          element={<AddEditVehicleBrand />}
        />

        {/* Model in Brand */}
        <Route
          path="/display-vehicle-models"
          element={<DisplayVehicleModel />}
        />
        <Route
          path="/create-edit-vehicle-model"
          element={<AddEditVehicleModel />}
        />

        {/* referal config */}
        <Route path="/display-referal" element={<DispayReferalConfig />} />
        <Route path="/create-edit-referal" element={<AddEditReferalConfig />} />

        {/* delivery Range */}
        <Route
          path="/display-deliveryrange"
          element={<DisplayDeliveryRange />}
        />
        <Route
          path="/create-edit-deliveryrange"
          element={<AddEditDeliveryRange />}
        />

        {/* Delivery Radius */}
        <Route path="/display-delivery-radius" element={<DisplayRadius />} />
        <Route path="/create-edit-radius" element={<AddEditRadius />} />

        {/* Tax config */}
        <Route path="/display-taxfee" element={<DisplayTaxConfig />} />
        <Route path="/create-edit-taxfee" element={<AddEditTaxConfig />} />

        {/* Users */}
        <Route path="/display-users" element={<DisplayUsers />} />
        <Route path="/view-user-details" element={<ViewUserDetails />} />

        {/* Employees */}
        <Route path="/display-employees" element={<DisplayEmployees />} />
        <Route path="/create-edit-employee" element={<AddEditEmployee />} />

        {/* Time Slots */}
        <Route path="/display-timeslots" element={<DisplayTimeslot />} />
        <Route path="/create-edit-timeslots" element={<AddEditTimeSlots />} />

        <Route path="/push-notifications" element={<PushNotifications />} />

        {/* roles and permission */}
        <Route path="/display-roles" element={<DisplayRoles />} />
        <Route path="/create-edit-roles" element={<AddEditRoles />} />
        <Route path="/display-role-permissions" element={<RolePermissions />} />
        <Route path="/display-permissions" element={<Permissions />} />

        {/* Bank Details  */}
        <Route
          path="/create-edit-bank-details"
          element={<AddEditBankDetails />}
        />

        {/* Cancellation policy */}
        <Route
          path="/display-cancellation-policy"
          element={<DisplayCancellationPolicy />}
        />
        <Route
          path="/create-edit-cancellation-policy"
          element={<AddEditCancellationPolicy />}
        />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/details" element={<Details />} />
      </Routes>
    </>
  );
};

export default PageRoutes;
